import type { GetStaticProps } from 'next';
import { Microsites } from 'constants/constants';
import { getRankingStaticProps } from '@/main/lib/utils/miscUtils/getRankingStaticProps';
import RankingFranchiseNextPage from 'src/pages/ranking/[franchiseSlug]';

export default RankingFranchiseNextPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const { slug } = context.params as { slug: string };

  const modifiedContext = {
    ...context,
    params: {
      ...context.params,
      franchiseSlug: slug,
    },
  };

  return getRankingStaticProps(modifiedContext, { platformCD: Microsites.Well });
};

export const getStaticPaths = () => {
  const paths = [{ params: { slug: 'best-places-families' } }];

  return {
    fallback: 'blocking',
    paths,
  };
};
